import { ControlsBaseComponent } from './../shared/components/controls-base.component';
import { Component } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { JsonDynamicComponentService } from '../json-dynamic-component.service';
import { CommonUtilsService } from '../shared/common-utils.service';

@Component({
  selector: 'ra-checkbox-control',
  templateUrl: './checkbox-control.component.html',
  styleUrls: ['./checkbox-control.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  standalone: false,
})
export class CheckboxControlComponent extends ControlsBaseComponent {
  constructor(
    protected jsonDynamicComponentService: JsonDynamicComponentService,
    protected commonUtils: CommonUtilsService,
  ) {
    super(jsonDynamicComponentService, commonUtils);
  }
}
